import { render, staticRenderFns } from "./addPlatModal.vue?vue&type=template&id=1359e9ad&scoped=true"
import script from "./addPlatModal.vue?vue&type=script&lang=js"
export * from "./addPlatModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1359e9ad",
  null
  
)

export default component.exports